// Library-Neighbors — sessionStorage-Bridge zwischen LibraryPage und
// AssetDetailPage damit J/K/Arrow-Navigation den aktuellen Library-Filter
// + Sort-State respektiert.
//
// LibraryPage schreibt die geordneten Asset-IDs nach jedem Fetch-Success.
// AssetDetailPage liest die Liste beim Mount, findet die aktuelle ID +
// computet prev/next. Bei direkten URL-navigation (kein LibraryPage-visit
// vorher) ist die Liste leer und die Tastaturshortcuts deaktiviert —
// nicht-breaking progressive enhancement.
//
// sessionStorage statt localStorage: Liste ist tab-scoped, beim Schließen weg.
// Bei direct-tab-Open auf /assets/:id soll keine stale-list aus früherer
// Library-Visit geladen werden.

const STORAGE_KEY = 'gf-library-asset-ids';
// Redesign S2: ob die gespeicherte Liste ALLE Treffer enthält (Infinite-Scroll
// hat keine weiteren Seiten). Sonst zeigt das Asset-Detail „n von N+“ statt
// einer Gesamtzahl, die nur die Länge der geladenen Seiten ist (Prod-Befund
// 2026-10-10: „1 von 100“ bei 8.224 Assets).
const COMPLETE_KEY = 'gf-library-asset-ids-complete';

export function saveLibraryAssetIds(ids: string[], complete = true): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    sessionStorage.setItem(COMPLETE_KEY, complete ? '1' : '0');
  } catch {
    // sessionStorage kann fail wenn quota voll oder Storage disabled.
    // Silent — feature ist progressive enhancement, kein Critical-Path.
  }
}

export function loadLibraryAssetIds(): string[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string');
  } catch {
    return [];
  }
}

/** Enthält die gespeicherte Liste alle Treffer? Unbekannt (alt/fehlend) → false. */
export function loadLibraryListComplete(): boolean {
  try {
    return sessionStorage.getItem(COMPLETE_KEY) === '1';
  } catch {
    return false;
  }
}

export function getNeighbors(
  ids: readonly string[],
  currentId: string,
): { prev: string | null; next: string | null } {
  const idx = ids.indexOf(currentId);
  if (idx === -1) {
    return { prev: null, next: null };
  }
  return {
    prev: idx > 0 ? ids[idx - 1] : null,
    next: idx < ids.length - 1 ? ids[idx + 1] : null,
  };
}
